import React from "react";
import PaymentTerms from "../components/ui/PaymentTerms";

const PaymentTermsPage = () => {
  return (
    <div className="font-body bg-[#FAF8F2] min-h-screen">
      <PaymentTerms />
    </div>
  );
};

export default PaymentTermsPage;
